document.addEventListener('DOMContentLoaded', function() {
  const seuil = 59;

  // Créer le bandeau
  const bandeau = document.createElement('div');
  bandeau.id = 'livraison-gratuite';
  bandeau.style.backgroundColor = '#3B0066';
  bandeau.style.color = 'white';
  bandeau.style.textAlign = 'center';
  bandeau.style.padding = '10px';
  bandeau.style.fontWeight = 'bold';
  bandeau.style.width = '100%';
  bandeau.style.display = 'block';
  bandeau.style.animation = 'pulse 2s infinite';
  bandeau.style.boxSizing = 'border-box';
  bandeau.style.zIndex = '9999';

  // Ajouter le bandeau au début du body
  document.body.prepend(bandeau);

  // Ajouter animation pulse via JS
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.03); }
      100% { transform: scale(1); }
    }
    #livraison-gratuite { animation: pulse 2s infinite; }
  `;
  document.head.appendChild(style);

  // Fonction pour mettre à jour le texte selon le panier
  function updateBandeau() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const montantPanier = cart.total_price / 100;
        const reste = seuil - montantPanier;
        if (reste > 0) {
          bandeau.textContent = `Plus que ${reste.toFixed(2)}€ pour profiter de la livraison gratuite !`;
        } else {
          bandeau.textContent = `Félicitations ! Livraison gratuite activée.`;
        }
      });
  }

  updateBandeau();
  document.addEventListener('cart:updated', updateBandeau);
});
